import script from "./ButtonIconNeutralPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonIconNeutralPrimary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonIconNeutralPrimary.vue?vue&type=style&index=0&id=019a6b23&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019a6b23"]])

export default __exports__